// src/data/sampleBooks.js

const sampleBooks = [
  {
    id: "book1",
    title: "The Adventures of Tom Sawyer",
    author: "Mark Twain",
    cefrLevels: ["A2", "B1"],
    coverImage: "/covers/tom-sawyer.jpg",
    coverImageHorizontal: "/banners/tom-sawyer-hero.jpg",
    description: "Tom Sawyer is a mischievous boy living along the Mississippi River who loves adventure and trouble. He skips school, hunts for treasure with Huck Finn, witnesses a murder, and discovers the true meaning of friendship.",
    wordCount: "~70000",
    chapters: 35,
    genres: ["Adventure", "Children's", "Humor"],
    quizCount: 5,
    rating: 4.5,
    progress: { percent: 0 },
    relatedIds: ["book2", "book3"],
    isFeatured: true,
  },
  {
    id: "book2",
    title: "Alice in Wonderland",
    author: "Lewis Carroll",
    cefrLevels: ["B1", "B2"],
    coverImage: "/covers/alice.jpg",
    coverImageHorizontal: "/banners/alice-hero.jpg",
    description: "Alice in Wonderland follows a curious young girl who tumbles down a rabbit hole into a whimsical world full of talking animals, mad tea parties, and puzzling riddles. Her magical journey challenges her imagination and sense of reality as she encounters the Cheshire Cat, the Queen of Hearts, and other unforgettable characters.",
    wordCount: "~27000",
    chapters: 12,
    genres: ["Fantasy", "Surreal", "Children's"],
    quizCount: 4,
    rating: 4.3,
    progress: { percent: 0 },
    relatedIds: ["book1", "book3"]
  },
  {
    id: "book3",
    title: "The Secret Garden",
    author: "Frances Hodgson Burnett",
    cefrLevels: ["A2", "B1"],
    coverImage: "/covers/secret-garden.jpg",
    coverImageHorizontal: "/banners/secret-garden-hero.jpg",
    description: "After the death of her parents, spoiled Mary Lennox is sent to live with her reclusive uncle in Yorkshire. There, she discovers a hidden, locked garden and, with the help of new friends, brings it and her own spirit back to life.",
    wordCount: "~80000",
    chapters: 27,
    genres: ["Drama", "Coming-of-Age", "Friendship"],
    quizCount: 6,
    rating: 4.6,
    progress: { percent: 0 },
    relatedIds: ["book1", "book2"]
  },
  {
    id: "book4",
    title: "White Fang",
    author: "Jack London",
    cefrLevels: ["B1", "B2"],
    coverImage: "/covers/white-fang.jpg",
    coverImageHorizontal: "/banners/white-fang-hero.jpg",
    description: "White Fang, a wild wolf-dog born in the Yukon wilderness, learns to survive the harsh laws of nature and man. His journey from savage freedom to domesticated loyalty explores the struggle between civilization and the wild.",
    wordCount: "~52000",
    chapters: 25,
    genres: ["Adventure", "Nature", "Survival"],
    quizCount: 5,
    rating: 4.4,
    progress: { percent: 0 },
    relatedIds: ["book5", "book6"]
  },
  {
    id: "book5",
    title: "Dr. Jekyll and Mr. Hyde",
    author: "Robert Louis Stevenson",
    cefrLevels: ["B1", "B2"],
    coverImage: "/covers/jekyll-hyde.jpg",
    coverImageHorizontal: "/banners/jekyll-hyde-hero.jpg",
    description: "A London lawyer investigates strange events surrounding his friend, Dr. Jekyll, and the violent, mysterious Mr. Hyde. As secrets unfold, he discovers they are the same man�torn between good and evil in a chilling tale of dual identity.",
    wordCount: "~26000",
    chapters: 10,
    genres: ["Horror", "Gothic", "Mystery"],
    quizCount: 4,
    rating: 4.1,
    progress: { percent: 0 },
    relatedIds: ["book7", "book8"]
  },
  {
    id: "book6",
    title: "Pride and Prejudice",
    author: "Jane Austen",
    cefrLevels: ["B2", "C1"],
    coverImage: "/covers/pride-prejudice.jpg",
    coverImageHorizontal: "/banners/pride-prejudice-hero.jpg",
    description: "A sharp, witty tale of manners and misunderstandings as Elizabeth Bennet navigates love, class, and family pride. Her clashes with the enigmatic Mr. Darcy reveal truths about prejudice and the human heart.",
    wordCount: "~122000",
    chapters: 61,
    genres: ["Romance", "Drama", "Social Commentary"],
    quizCount: 7,
    rating: 4.7,
    progress: { percent: 0 },
    relatedIds: ["book10"]
  },
  {
    id: "book7",
    title: "Heart of Darkness",
    author: "Joseph Conrad",
    cefrLevels: ["C1", "B2"],
    coverImage: "/covers/heart-darkness.jpg",
    coverImageHorizontal: "/banners/heart-darkness-hero.jpg",
    description: "A sailor named Marlow recounts his journey up the Congo River to find the elusive ivory trader Kurtz. As he ventures deeper into the African wilderness, Marlow confronts the darkness within civilization and the human soul.",
    wordCount: 38000,
    chapters: 3,
    genres: ["Adventure", "Colonialism", "Psychological"],
    quizCount: 5,
    rating: 4.2,
    progress: { percent: 0 },
    relatedIds: ["book8", "book9"]
  },
  {
    id: "book8",
    title: "Dracula",
    author: "Bram Stoker",
    cefrLevels: ["C1", "B2"],
    coverImage: "/covers/dracula.jpg",
    coverImageHorizontal: "/banners/dracula-hero.jpg",
    description: "When Jonathan Harker travels to Transylvania to help Count Dracula with a real estate deal, he uncovers a terrifying truth. As Dracula arrives in England, a group of friends must battle the ancient vampire to save themselves and their world.",
    wordCount: 90000,
    chapters: 27,
    genres: ["Horror", "Gothic", "Supernatural"],
    quizCount: 8,
    rating: 4.5,
    progress: { percent: 0 },
    relatedIds: ["book5", "book7"],
    isFeatured: true,
  },
  {
    id: "book9",
    title: "Brave New World",
    author: "Aldous Huxley",
    cefrLevels: ["C1", "B2"],
    coverImage: "/covers/brave-new-world.jpg",
    coverImageHorizontal: "/banners/brave-new-world-hero.jpg",
    description: "In a dystopian future, people live under strict social control, engineered from birth for their roles. As Bernard Marx questions this engineered happiness, he uncovers the true cost of a 'perfect' world and the meaning of freedom.",
    wordCount: 63000,
    chapters: 18,
    genres: ["Science Fiction", "Dystopian", "Political Fiction"],
    quizCount: 6,
    rating: 4.4,
    progress: { percent: 0 },
    relatedIds: ["book10", "book7"]
  },
  {
    id: "book10",
    title: "To the Lighthouse",
    author: "Virginia Woolf",
    cefrLevels: ["C1", "B2"],
    coverImage: "/covers/to-the-lighthouse.jpg",
    coverImageHorizontal: "/banners/to-the-lighthouse-hero.jpg",
    description: "Set on the Scottish Isle of Skye, this modernist novel explores the Ramsay family�s shifting inner worlds across time, weaving memories, art, and family tensions into a profound meditation on perception and loss.",
    wordCount: 63000,
    chapters: 19,
    genres: ["Modernist", "Family Saga", "Psychological Fiction"],
    quizCount: 3,
    rating: 4.0,
    progress: { percent: 0 },
    relatedIds: ["book6", "book9"],
    isFeatured: true,
  },
];
// Add books the same way later on.
export default sampleBooks;
